import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import {DatePicker, Dropdown, Button, Space} from 'antd';
import {useTranslation} from 'react-i18next';
import dayjs from 'dayjs';
import Search from '../../../Search';
import {dateHelpers, objectHelpers} from '../../../../utils/helpers';
import {
  StyledTransactionMatchingPanelFilterSpace,
  StyledTransactionMatchingPanelAmountSpace
} from './StyledTransactionMatchingPanel';

const amountTypeOptions = [
  { key: '<', label: '≤' },
  { key: '>', label: '≥' }
];

const defaultFilter = {
  amount: '',
  amountType: '<',
  dateRange: null,
  search: ''
};

const searchProps = {
  allowClear: true,
  minSearchSymbolsLength: 1
};

const TransactionMatchingPanelFilters = ({
  defaultValues = defaultFilter,
  onFilter,
  ...rest
}) => {
  const [filter, setFilter] = useState(objectHelpers.isEmptyObject(defaultValues) ? defaultFilter : defaultValues);
  const [t] = useTranslation('main');

  const handleOnFilter = (key, value) => {
    const params = {...filter, [key]: value};
    setFilter(params);
    onFilter?.(params);
  }

  const amountTypeLabel = useMemo(
    () => amountTypeOptions.find(({ key }) => key === filter.amountType)?.label || '',
    [filter.amountType]
  );

  return (
    <StyledTransactionMatchingPanelFilterSpace size='small' {...rest}>
      <Search
        {...searchProps}
        defaultValue={filter.search}
        onSearch={(value) => handleOnFilter('search', value)}
        placeholder={t('search')}
        value={filter.search}
        size='middle'
      />

      <Space size='small' className='transaction-matching-panel-filters-right-space'>
        <StyledTransactionMatchingPanelAmountSpace size={0}>
          <Search
            {...searchProps}
            defaultValue={filter.amount}
            placeholder={t('amount')}
            onSearch={(value) => handleOnFilter('amount', value)}
            type='number'
            suffix={undefined}
            style={{ width: '100%' }}
            value={filter.amount}
          />
          <Dropdown
            menu={{
              items: [
                { key: '<', label: '≤' },
                { key: '>', label: '≥' }
              ],
              onClick: (e) => handleOnFilter('amountType', e.key)
            }}
            trigger={['click']}
          >
            <Button>
              {amountTypeLabel}
            </Button>
          </Dropdown>
        </StyledTransactionMatchingPanelAmountSpace>

        <DatePicker.RangePicker
          disabledDate={(current) => current.isAfter(dayjs())}
          panelRender={dateHelpers.getDatePickerPanelRender}
          onChange={(value) => handleOnFilter('dateRange', value)}
          format='DD MMM YYYY'
          size='middle'
          superNextIcon={false}
          superPrevIcon={false}
          value={filter.dateRange}
        />
      </Space>
    </StyledTransactionMatchingPanelFilterSpace>
  );
};

TransactionMatchingPanelFilters.propTypes = {
  onFilter: PropTypes.func,
};

export default TransactionMatchingPanelFilters;

